import { Slide, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const success = (title, id) => {
    toast.dismiss();
    toast.success(title, {
        position: "top-right",
        toastId: id,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        autoClose: 15000,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
    })
}
export const warning = (title, id) => {
    toast.dismiss();
    return toast.warn(title, {
        position: "top-right",
        toastId: id,
        hideProgressBar: false,
        closeOnClick: true,
        autoClose: 15000,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
    })
}
export const error = (title, id) => {
    toast.dismiss();
    toast.error(title, {
        position: "top-right",
        toastId: id,
        hideProgressBar: false,
        closeOnClick: true,
        autoClose: 15000,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
    })
}
export const info = (title, id) => {
    toast.dismiss();
    toast.info(title, {
        position: "top-right",
        toastId: id,
        autoClose: 15000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
    })
}
